import { jsx } from 'react/jsx-runtime';
import { Button } from '@fabric-app/ui/components/Button';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { styled } from 'styled-components';
import { getEmbedResourcePath } from './utils.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { IconLinkArrow } from '@fabric-app/icons/svg';
import { isInNativeApp } from '@fabric-app/compat/capabilities/platform';

const ButtonArrowOpen = styled(Button).attrs(({ resourceId, kind, className, style, onClick }) => {
  return {
    variant: "bg-secondary",
    shape: "square",
    onPointerDown: (e) => e.stopPropagation(),
    as: isInNativeApp() ? "button" : LinkExternal,
    onClick: isInNativeApp() ? onClick : void 0,
    className,
    href: getEmbedResourcePath({
      resourceId,
      type: kind
    }),
    style: {
      height: 23,
      width: 23,
      padding: 0,
      ...style
    },
    children: /* @__PURE__ */ jsx(IconLinkArrow, {
      style: {
        fontSize: "0.55rem",
        color: cssVar["color-text-primary"],
        pointerEvents: "none"
      }
    })
  };
}).withConfig({
  displayName: "ButtonArrowOpen",
  componentId: "sc-f7df3708-0"
})([
  ``
]);

export { ButtonArrowOpen };
//# sourceMappingURL=ButtonArrowOpen.js.map
